import React, { ComponentType } from 'react';
import { connect } from 'react-redux';
import { ReduxState } from '../../../../../ReduxStorage/state';
import { FilteredCourses } from '.';
// TODO: move these out of the legacy CoursesPage container
import { loadMoreResults } from '../../dispatchers';
import { selectFilteredCourses, selectShowMore } from '../../selectors';
import { ConnectedSortBySelector } from '../../FilterMenu/Connectors';
import { ConnectedFilteredCoursesProps } from './types';
import { ConnectedCourseCard } from '../../../../components/Marketing/CourseCard/connector';
import { Button } from '../../../../components/Marketing/Button';

const _FilteredCourses: ComponentType<ConnectedFilteredCoursesProps> = (
  props
) => {
  return (
    <FilteredCourses
      {...props}
      SortByComponent={ConnectedSortBySelector}
      CourseCardComponent={ConnectedCourseCard}
      ShowMoreComponent={Button}
    />
  );
};

export const ConnectedFilteredCourses = connect(
  (state: ReduxState) => ({
    courses: selectFilteredCourses(state),
    showMore: selectShowMore(state),
  }),
  (dispatch) => ({
    handleShowMoreClick: () => {
      dispatch(loadMoreResults());
    },
  })
)(_FilteredCourses);
